var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _polygon, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsfumed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "180px",
    height: "100px",
    viewBox: "0 0 180 100",
    enableBackground: "new 0 0 180 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.406,
    y: 28.116,
    fill: "#0080C7",
    width: 6.798,
    height: 7.096
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.075,
    y: 14.019,
    fill: "#0080C7",
    width: 6.794,
    height: 7.096
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94.836,
    y: 6.845,
    fill: "#898989",
    width: 6.797,
    height: 7.096
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.462,
    y: 42.433,
    fill: "#898989",
    width: 6.797,
    height: 7.093
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88.349,
    y: 28.116,
    fill: "#898989",
    width: 6.797,
    height: 7.096
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0080C7",
    d: "M140.063,65.204c0,4.289-3.062,7.002-7.141,7.002c-3.65,0-6.712-3.34-6.712-7.002 c0-3.732,2.784-7.076,6.556-7.076C136.848,58.128,140.063,60.922,140.063,65.204 M139.829,75.589l3.532-0.473v-27.8l-3.766,0.627 v9.517c-1.769-1.611-4.281-2.871-6.986-2.871c-5.649,0-10.24,4.449-10.166,10.54c0.08,5.545,4.438,10.616,10.166,10.616 c2.94,0,5.338-1.18,7.222-3.344v3.188L139.829,75.589L139.829,75.589z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0080C7",
    d: "M106.514,65.717c-0.471-4.129,2.159-7.589,6.437-7.589c1.331,0,2.59,0.316,3.45,1.3L106.514,65.717z  M121.585,60.057c-2.163-3.538-4.671-5.466-8.91-5.466c-5.295,0-9.93,4.6-9.93,10.027c0,6.328,4.161,11.125,10.56,11.125 c3.098,0,5.414-1.297,7.885-3.029l-0.744-3.971c-2.039,1.613-4.674,3.461-7.379,3.461c-2.353,0-4.195-1.223-5.457-3.226 L121.585,60.057z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0080C7",
    d: "M77.823,75.116V61.979c0-3.066,2.629-4.047,4.317-4.047c2.314,0,3.217,1.453,3.217,3.658v14.152l3.766-0.627 V61.979c0-3.066,2.63-4.047,4.318-4.047c2.313,0,3.219,1.453,3.219,3.658v14.152l3.766-0.627V60.882 c0-4.363-3.021-6.291-6.592-6.291c-2.709,0-5.103,1.336-5.887,2.908c-0.981-2.281-2.825-2.908-5.18-2.908 c-2.393,0-4.277,1.219-5.024,2.713h-0.077v-2.713l-3.611,0.627v20.527L77.823,75.116z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0080C7",
    d: "M67.146,55.218v11.09c0,4.285-2.63,6.096-5.611,6.096c-2.315,0-4.395-0.941-4.395-3.893v-13.92l-3.767,0.629 v13.842c0,4.756,3.767,6.686,7.81,6.686c2.354,0,4.747-0.905,5.964-2.951h0.08v2.951l3.688-0.629V54.591L67.146,55.218z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0080C7",
    points: "41.399,75.116 41.399,62.847 49.64,62.847 49.64,59.31 41.399,59.31 41.399,51.682 52.112,51.682  51.446,48.141 37.552,48.141 37.552,75.589 "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.406,
    y: 14.019,
    fill: "#898989",
    width: 6.798,
    height: 7.096
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsfumed);
export default __webpack_public_path__ + "static/media/clientsfumed.ea28202be3de13079b87624fbfa299bd.svg";
export { ForwardRef as ReactComponent };